import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import ListFuelPump from "./ListFuelPump";
import FormFuelPump from "./FormFuelPump";

function FuelPumpRoutes() {
  return (
    <Switch>
      <Route
        path="/:farm_id/fuel-pump/:fuel_pump_id"
        component={FormFuelPump}
      />
      <Route
        path="/:farm_id/fuel-pump/add/"
        component={FormFuelPump}
        fuel_pump_id={-1}
      />
      <Route
        path="/:farm_id/fuel-pump/add"
        component={FormFuelPump}
        fuel_pump_id={-1}
      />
      <Route path="/:farm_id/fuel-pump/" component={ListFuelPump} />
    </Switch>
  );
}

export default withRouter(FuelPumpRoutes);
